import "core-js/modules/es6.regexp.replace";
import { CONSUMER_HOST, PAY_HOST, IDENTITY_HOST } from './constants';
export var snakeCase = function snakeCase(string) {
  return string.trim().toLowerCase().replace(/ /gi, '_').replace(/\W/gi, '');
};
/**
 * Checks a URL for any production references that can be changed to point to a local dev
 * environment.
 *
 * @param {String} href the URL being formatted
 * @param {Object} config an object containing hosts
 */

export function localizeHref(href, _ref) {
  var _ref$consumerHost = _ref.consumerHost,
      consumerHost = _ref$consumerHost === void 0 ? CONSUMER_HOST : _ref$consumerHost,
      _ref$payHost = _ref.payHost,
      payHost = _ref$payHost === void 0 ? PAY_HOST : _ref$payHost,
      _ref$identityHost = _ref.identityHost,
      identityHost = _ref$identityHost === void 0 ? IDENTITY_HOST : _ref$identityHost;
  var consumerVar = '{CONSUMER_HOST}';
  var payVar = '{PAY_HOST}';
  var identityVar = '{IDENTITY_HOST}';
  return href.replace(consumerVar, consumerHost ? "//".concat(consumerHost) : '').replace(payVar, payHost ? "//".concat(payHost) : '').replace(identityVar, identityHost ? "//".concat(identityHost) : '');
}
export function noop() {// No operation performed.
}